<template>
  <div class="step-country">
    <h2 class="step-country__title">Onde deseja agendar?</h2>
    <p class="step-country__hint">
      Pode marcar no seu país ou em Portugal, por exemplo se estiver de férias.
    </p>

    <div class="step-country__grid">
      <button
        v-for="option in options"
        :key="option.iso"
        type="button"
        class="country-choice"
        :class="{ 'country-choice--selected': selectedIso === option.iso }"
        @click="$emit('select', option.iso)"
      >
        <span class="country-choice__flag" aria-hidden="true">{{
          option.flag
        }}</span>
        <span class="country-choice__name">{{ option.title }}</span>
        <span class="country-choice__caption">{{ option.caption }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import {
  countryDisplayName,
  countryFlagEmoji,
  normalizeCountryIso,
} from "@/utils/appointmentCountries";

export default {
  name: "AppointmentStepCountry",
  props: {
    residenceCountry: {
      type: String,
      required: true,
    },
    selectedIso: {
      type: String,
      default: null,
    },
  },
  emits: ["select"],
  computed: {
    options() {
      const residence = normalizeCountryIso(this.residenceCountry);
      return [
        {
          iso: residence,
          flag: countryFlagEmoji(residence),
          title: "No meu país",
          caption: countryDisplayName(residence),
        },
        {
          iso: "PT",
          flag: countryFlagEmoji("PT"),
          title: "Em Portugal",
          caption: "Portugal",
        },
      ];
    },
  },
};
</script>
